/* Browser-local true-scale PDF generator for the sticker size guide. */
(function (global) {
  'use strict';

  function french() { return /^fr(?:-|$)/i.test(global.document && global.document.documentElement.lang || ''); }

  var PAPERS = {
    letter: { widthPt: 612, heightPt: 792, label: 'Letter' },
    a4: { widthPt: 595.28, heightPt: 841.89, label: 'A4' },
  };
  var LOCKED = { circle: true, square: true };
  var SHAPES = { circle: true, square: true, rectangle: true, oval: true };
  var PAGE_MARGIN_PT = 24;
  var HEADER_PT = 38;
  var FOOTER_PT = 44;
  var LABEL_BAND_PT = 16;
  var ITEM_GAP_PT = 12;

  function round(value, places) {
    var factor = Math.pow(10, places || 0);
    return Math.round(Number(value) * factor) / factor;
  }

  function trim(value) {
    return String(round(value, 2));
  }

  function inchesToPoints(value) {
    return round(Number(value) * 72, 2);
  }

  function normalizeSelection(input) {
    var shape = String(input && input.shape || '').toLowerCase();
    if (!SHAPES[shape]) throw new Error('Choose a supported sticker shape.');

    var width = Number(input.widthIn);
    var height = LOCKED[shape] ? width : Number(input.heightIn);
    if (!isFinite(width) || !isFinite(height) || width < 0.5 || height < 0.5 || width > 12 || height > 12) {
      throw new Error('Sticker dimensions must be between 0.5 and 12 inches.');
    }

    width = round(width, 2);
    height = round(height, 2);
    var name = french() ? { circle: 'Cercle', square: 'Carré', rectangle: 'Rectangle', oval: 'Ovale' }[shape] : shape.charAt(0).toUpperCase() + shape.slice(1);
    var dimensions = LOCKED[shape]
      ? trim(width) + (french() ? ' po' : ' in')
      : trim(width) + ' × ' + trim(height) + (french() ? ' po' : ' in');

    return {
      id: shape + ':' + trim(width) + 'x' + trim(height),
      shape: shape,
      widthIn: width,
      heightIn: height,
      label: name + ' · ' + dimensions,
    };
  }

  function pageContent(widthPt, heightPt) {
    return {
      xPt: PAGE_MARGIN_PT,
      yPt: PAGE_MARGIN_PT + HEADER_PT,
      widthPt: widthPt - (PAGE_MARGIN_PT * 2),
      heightPt: heightPt - (PAGE_MARGIN_PT * 2) - HEADER_PT - FOOTER_PT,
    };
  }

  function toPackItem(input) {
    var selection = normalizeSelection(input);
    var widthPt = inchesToPoints(selection.widthIn);
    var heightPt = inchesToPoints(selection.heightIn);
    return {
      selection: selection,
      widthPt: widthPt,
      heightPt: heightPt,
      boxWidthPt: widthPt + ITEM_GAP_PT,
      boxHeightPt: heightPt + LABEL_BAND_PT + ITEM_GAP_PT,
    };
  }

  function fits(item, content) {
    return item.boxWidthPt <= content.widthPt + 0.01 &&
      item.boxHeightPt <= content.heightPt + 0.01;
  }

  function createPage(widthPt, heightPt, orientation) {
    return {
      widthPt: widthPt,
      heightPt: heightPt,
      orientation: orientation,
      content: pageContent(widthPt, heightPt),
      items: [],
    };
  }

  function packIntoPages(items, widthPt, heightPt, orientation) {
    if (!items.length) return [];

    var ordered = items.slice().sort(function (left, right) {
      return right.boxHeightPt - left.boxHeightPt || right.boxWidthPt - left.boxWidthPt;
    });
    var pages = [];
    var page = null;
    var x = 0;
    var y = 0;
    var shelfHeight = 0;

    function startPage() {
      page = createPage(widthPt, heightPt, orientation);
      pages.push(page);
      x = page.content.xPt;
      y = page.content.yPt;
      shelfHeight = 0;
    }

    startPage();
    ordered.forEach(function (item) {
      var contentRight = page.content.xPt + page.content.widthPt;
      var contentBottom = page.content.yPt + page.content.heightPt;

      if (x + item.boxWidthPt > contentRight + 0.01) {
        x = page.content.xPt;
        y += shelfHeight;
        shelfHeight = 0;
      }

      if (y + item.boxHeightPt > contentBottom + 0.01) {
        startPage();
      }

      page.items.push({
        selection: item.selection,
        xPt: x,
        yPt: y,
        widthPt: item.widthPt,
        heightPt: item.heightPt,
        boxWidthPt: item.boxWidthPt,
        boxHeightPt: item.boxHeightPt,
      });
      x += item.boxWidthPt;
      shelfHeight = Math.max(shelfHeight, item.boxHeightPt);
    });

    return pages;
  }

  function cannotFitError(item, paper) {
    return new Error(item.selection.label + ' cannot fit on ' + paper.label + ' paper at true size.');
  }

  function packSelections(rawSelections, paperKey) {
    var paper = PAPERS[paperKey] || PAPERS.letter;
    var portraitContent = pageContent(paper.widthPt, paper.heightPt);
    var landscapeContent = pageContent(paper.heightPt, paper.widthPt);
    var portraitItems = [];
    var landscapeItems = [];

    (rawSelections || []).map(toPackItem).forEach(function (item) {
      if (fits(item, portraitContent)) portraitItems.push(item);
      else if (fits(item, landscapeContent)) landscapeItems.push(item);
      else throw cannotFitError(item, paper);
    });

    var pages = packIntoPages(portraitItems, paper.widthPt, paper.heightPt, 'portrait');
    landscapeItems.forEach(function (item) {
      pages = pages.concat(packIntoPages([item], paper.heightPt, paper.widthPt, 'landscape'));
    });
    return pages;
  }

  function pdfNumber(value) {
    var rounded = round(value, 2);
    return String(rounded);
  }

  function pdfString(value) {
    return String(value)
      .replace(/\\/g, '\\\\')
      .replace(/\(/g, '\\(')
      .replace(/\)/g, '\\)')
      .replace(/[\u0080-\u00ff]/g, function (character) { return '\\' + character.charCodeAt(0).toString(8).padStart(3, '0'); })
      .replace(/[^\x20-\x7E]/g, '');
  }

  function asciiLabel(selection) {
    return selection.label
      .replace(/ · /g, ' - ')
      .replace(/ × /g, ' x ');
  }

  function textCommand(text, x, y, size) {
    return 'BT /F1 ' + pdfNumber(size) + ' Tf ' + pdfNumber(x) + ' ' + pdfNumber(y) +
      ' Td (' + pdfString(text) + ') Tj ET';
  }

  function rectanglePath(x, y, width, height) {
    return [
      pdfNumber(x),
      pdfNumber(y),
      pdfNumber(width),
      pdfNumber(height),
      're S',
    ].join(' ');
  }

  function ellipsePath(x, y, width, height) {
    var kappa = 0.55228475;
    var radiusX = width / 2;
    var radiusY = height / 2;
    var centerX = x + radiusX;
    var centerY = y + radiusY;
    return [
      pdfNumber(centerX + radiusX), pdfNumber(centerY), 'm',
      pdfNumber(centerX + radiusX), pdfNumber(centerY + (radiusY * kappa)),
      pdfNumber(centerX + (radiusX * kappa)), pdfNumber(centerY + radiusY),
      pdfNumber(centerX), pdfNumber(centerY + radiusY), 'c',
      pdfNumber(centerX - (radiusX * kappa)), pdfNumber(centerY + radiusY),
      pdfNumber(centerX - radiusX), pdfNumber(centerY + (radiusY * kappa)),
      pdfNumber(centerX - radiusX), pdfNumber(centerY), 'c',
      pdfNumber(centerX - radiusX), pdfNumber(centerY - (radiusY * kappa)),
      pdfNumber(centerX - (radiusX * kappa)), pdfNumber(centerY - radiusY),
      pdfNumber(centerX), pdfNumber(centerY - radiusY), 'c',
      pdfNumber(centerX + (radiusX * kappa)), pdfNumber(centerY - radiusY),
      pdfNumber(centerX + radiusX), pdfNumber(centerY - (radiusY * kappa)),
      pdfNumber(centerX + radiusX), pdfNumber(centerY), 'c S',
    ].join(' ');
  }

  function pageContentStream(page, pageNumber, pageCount) {
    var commands = [
      'q',
      '1 0.353 0.122 RG',
      '2 w',
      pdfNumber(PAGE_MARGIN_PT) + ' ' + pdfNumber(page.heightPt - PAGE_MARGIN_PT - 20) +
        ' m ' + pdfNumber(page.widthPt - PAGE_MARGIN_PT) + ' ' +
        pdfNumber(page.heightPt - PAGE_MARGIN_PT - 20) + ' l S',
      'Q',
      textCommand(french() ? 'SPARKSTICKERS - COMPARAISON DES FORMATS' : 'SPARKSTICKERS SIZE COMPARISON', PAGE_MARGIN_PT, page.heightPt - PAGE_MARGIN_PT - 14, 13),
      '0 0 0 RG',
      '0.75 w',
    ];

    page.items.forEach(function (item) {
      var shapeY = page.heightPt - item.yPt - item.heightPt;
      commands.push(
        item.selection.shape === 'circle' || item.selection.shape === 'oval'
          ? ellipsePath(item.xPt, shapeY, item.widthPt, item.heightPt)
          : rectanglePath(item.xPt, shapeY, item.widthPt, item.heightPt)
      );
      commands.push(textCommand(asciiLabel(item.selection), item.xPt, shapeY - 11, 8));
    });

    commands.push(
      '1 w',
      pdfNumber(PAGE_MARGIN_PT) + ' 31 m ' + pdfNumber(PAGE_MARGIN_PT + 72) + ' 31 l S',
      textCommand(french() ? '1 po / 25,4 mm' : '1 in / 25.4 mm', PAGE_MARGIN_PT + 78, 28, 8),
      textCommand(french() ? 'Imprimez à taille réelle / 100 %. Désactivez Ajuster à la page.' : 'Print at Actual size / 100%. Turn off Fit to page.', PAGE_MARGIN_PT, 13, 8),
      textCommand('Page ' + pageNumber + (french() ? ' sur ' : ' of ') + pageCount, page.widthPt - 82, 13, 8)
    );
    return commands.join('\n');
  }

  function encodeAscii(value) {
    var bytes = new Uint8Array(value.length);
    for (var index = 0; index < value.length; index += 1) bytes[index] = value.charCodeAt(index) & 255;
    return bytes;
  }

  function serializePdf(objects) {
    var output = '%PDF-1.4\n%SparkStickers\n';
    var offsets = [0];

    for (var objectNumber = 1; objectNumber < objects.length; objectNumber += 1) {
      offsets[objectNumber] = output.length;
      output += objectNumber + ' 0 obj\n' + objects[objectNumber] + '\nendobj\n';
    }

    var xrefOffset = output.length;
    output += 'xref\n0 ' + objects.length + '\n';
    output += '0000000000 65535 f \n';
    for (var offsetIndex = 1; offsetIndex < objects.length; offsetIndex += 1) {
      output += String(offsets[offsetIndex]).padStart(10, '0') + ' 00000 n \n';
    }
    output += 'trailer\n<< /Size ' + objects.length + ' /Root 1 0 R >>\n';
    output += 'startxref\n' + xrefOffset + '\n%%EOF\n';
    return encodeAscii(output);
  }

  function buildPdf(selections, paperKey) {
    var pages = packSelections(selections, paperKey);
    if (!pages.length) throw new Error('Add at least one sticker size before downloading the PDF.');

    var objects = [null];
    var pageReferences = [];
    objects[1] = '';
    objects[2] = '';
    objects[3] = '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>';

    pages.forEach(function (page, index) {
      var pageObject = objects.length;
      var contentObject = pageObject + 1;
      var stream = pageContentStream(page, index + 1, pages.length);
      objects.push(
        '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + pdfNumber(page.widthPt) + ' ' +
          pdfNumber(page.heightPt) + '] /Resources << /Font << /F1 3 0 R >> >> /Contents ' +
          contentObject + ' 0 R >>'
      );
      objects.push('<< /Length ' + stream.length + ' >>\nstream\n' + stream + '\nendstream');
      pageReferences.push(pageObject + ' 0 R');
    });

    objects[1] = '<< /Type /Catalog /Pages 2 0 R >>';
    objects[2] = '<< /Type /Pages /Kids [' + pageReferences.join(' ') + '] /Count ' + pages.length + ' >>';
    return serializePdf(objects);
  }

  function downloadPdf(selections, paperKey, filename) {
    var bytes = buildPdf(selections, paperKey);
    var url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
    var link = document.createElement('a');
    link.href = url;
    link.download = filename || 'sparkstickers-size-comparison.pdf';
    link.click();
    setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 1000);
  }

  global.SparkSizeGuidePdf = {
    PAPERS: PAPERS,
    inchesToPoints: inchesToPoints,
    normalizeSelection: normalizeSelection,
    packSelections: packSelections,
    buildPdf: buildPdf,
    downloadPdf: downloadPdf,
  };
})(typeof window !== 'undefined' ? window : globalThis);
